<div *transloco="let t;" class="sidebar-menu absolute md:relative flex flex-col items-center z-10"
    [ngClass]="{'hidden':isCollapsed}">

    <!-- LOGO -->
    <div class="Kryptomon-logo">
        <a href="https://www.kryptomon.co/" target="_blank">
            <img class="Kryptomon-logo-open w-30" src="./assets/img/Kryptomon-logo.png" />
            <!-- <img class="Kryptomon-logo-close" src="./assets/img/k-logo.png" /> -->
        </a>
    </div>
    <!-- WALLET -->
    <div class="profile-text mt-4 cursor-pointer" (click)="walletClick()" [ktooltip]="t('shared.copy')"
        position="below">
        <p class="flex items-center justify-center w-40 h-5">
            <img class="pr-3 h-4" src="./assets/img/Icon/Icon-Copy-Gray.svg" />
            <span>{{addressText}}</span>
        </p>
    </div>
    <!-- PLAY -->
    <k-button check-cookies-expired class="pb-5" height="40px" (onClickAction)="playClick()">
        <img class="w-8 pr-3" src="./assets/img/Icon/Icon-Play.svg" />
        <span class="text-lg pr-3">{{t('shared.play') | uppercase}}</span>
    </k-button>
    <!-- NAVIGATION -->
    <div class="flex flex-col w-full px-6 overflow-y-auto">
        <div *ngFor="let item of navigationList" class="w-full text-base">
            <ng-container [ngTemplateOutlet]="navigationItem"
                [ngTemplateOutletContext]="{nav:item, node:0}"></ng-container>
        </div>
    </div>
    <ng-template #navigationItem let-item="nav" let-node="node" let-groupIsClosed="isClosed">
        <a *ngIf="item.target else singleItem"
            [routerLink]="!item.target.endsWith('/') ? item.target : [item.target, '']"
            [routerLinkActive]="'sidebar-menu-item-active'">
            <ng-container [ngTemplateOutlet]="singleItem"></ng-container>
        </a>
        <ng-template #singleItem>
            <div class="sidebar-menu-item w-full flex content-start py-2 cursor-pointer border-t border-t-k-gray hover:bg-k-gray "
                [ngClass]="{'hidden':groupIsClosed,'bg-k-gray': item.active}"
                (click)="item.isExpanded = !item.isExpanded" [style]="'padding-left:'+ node + 'px;'">
                <img class="w-4 mr-2" [src]="item.img" />
                <span>{{t(item.label)}}</span>
                <!-- <span *ngIf="item?.children" class="ml-auto ">{{item.isExpanded?'E':'C'}}</span> -->
                <fa-icon *ngIf="item?.children" class="ml-auto "
                    [icon]="item.isExpanded ? 'chevron-up' : 'chevron-down'"></fa-icon>
            </div>
        </ng-template>
        <div>
            <ng-container *ngFor="let child of item?.children">
                <ng-container [ngTemplateOutlet]="navigationItem"
                    [ngTemplateOutletContext]="{nav:child, node:node + 30, isClosed:!item.isExpanded}"></ng-container>
            </ng-container>
        </div>
    </ng-template>

    <!-- ACTION BUTTONS -->
    <div class="w-full px-6 mt-auto flex items-center justify-end">
        <k-button outline="true" class="mr-3" (onClickAction)="logOutClick()">
            <span>LOGOUT</span>
        </k-button>
        <k-button check-cookies-expired outline="true" roundedIcon="true" class=""
            (onClickAction)="actionMenu('close')">
            <fa-icon [icon]="'long-arrow-left'"></fa-icon>
        </k-button>
    </div>
</div>

<div class="w-12 h-full side-container-mobile z-10 cursor-pointer sm:cursor-default "
    (click)="checkIfIsMobile() ? actionMenu('open') : null " [ngClass]="{'hidden':!isCollapsed}">
    <k-button check-cookies-expired outline="true" roundedIcon="true" class="fixed bottom-3"
        (onClickAction)="actionMenu('open')">
        <fa-icon [icon]="'bars'"></fa-icon>
    </k-button>
</div>